import { atom } from 'jotai';
import { SuccessModalType } from 'types';

interface ICreatedSafe {
  option: SuccessModalType;
  name: string;
}

// TODO_R: [FAR]
export const createdSafeAtom = atom<ICreatedSafe | null>(null);
